export default "__VITE_ASSET__AubRHtod__"